import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { QCTimePerUserItem, QCWeekData } from '../model/user-qc-time.model';
import { ReportsService } from './reports.service';
import { MetricsToolbarFilters } from '../model/metrics-toolbar.model';

@Injectable()
export class MetricsDataService {
    private qcItemsSubject = new BehaviorSubject<QCTimePerUserItem[] | null>(null);
    private qcMetricsPerWeek = new BehaviorSubject<QCWeekData[] | null>(null);
    public lastSelectedDateRange = {
        startDate: '',
        endDate: '',
    };
    qcItems$ = this.qcItemsSubject.asObservable();
    qcMetricsPerWeek$ = this.qcMetricsPerWeek.asObservable();

    private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    constructor(private reportsService: ReportsService) {}

    /**
     * Fetches the qc items by triggering weekly and by user metrics endpoints.
     * @param {MetricsToolbarFilters} filters - The metrics filters containing the date range and params of the api requests.
     * @returns {void}
     */
    fetchQCItems(filters: MetricsToolbarFilters): void {
        this.loadingSubject.next(true);
        this.lastSelectedDateRange = filters.dateRange;

        // 1. Call User QC Time Items (with orgs/products)
        this.reportsService
            .getUserQCTimeItems(
                filters.dateRange.startDate,
                filters.dateRange.endDate,
                filters.organizations,
                filters.products,
            )
            .subscribe({
                next: (data) => {
                    this.qcItemsSubject.next(data);
                    this.loadingSubject.next(false);
                },
                error: (err) => {
                    this.qcItemsSubject.next([]);
                    this.loadingSubject.next(false);
                },
            });

        // 2. Call Performance Per Week (no orgs/products, just date range)
        this.reportsService
            .getPerformancePerWeek(filters.dateRange.startDate, filters.dateRange.endDate)
            .subscribe({
                next: (weekData) => {
                    this.qcMetricsPerWeek.next(weekData); // Create and use a new subject for this data
                    // Handle any UI updates, etc.
                },
                error: (err) => {
                    this.qcMetricsPerWeek.next([]);
                    // Optionally handle errors/UI
                },
            });
    }
}
